/* istanbul ignore file */
/* ignored due to prior App.test coverage being deleted due to low value while needing to retain test coverage */
import React from 'react'
import { Router } from 'react-router-dom'

import { HostServices } from '@ally/federated-types'
import { MetronomeProvider, muiBankTheme } from '@ally/metronome-ui'
import ErrorBoundary from '@ally/next-remote-error-boundary'

import Login from './Login'
import { HostServicesContext } from './HostServices'

// Only needed for DSR 24.15, as the current version of Transmitigator in host
// is slightly behind remote-login. This will be resolved after DSR 24.15 and
// this code can be removed
// eslint-disable-next-line @typescript-eslint/no-empty-function
const loggerNoop: any = () => {}
// Set the global logger
window.t12rLogger = window.t12rLogger || {
  log: loggerNoop,
  error: loggerNoop,
  warn: loggerNoop,
  info: loggerNoop,
  debug: loggerNoop,
  trace: loggerNoop,
  child: loggerNoop,
}

interface AppProps {
  services: HostServices
}
const App: React.FC<AppProps> = ({ services }) => {
  const name = 'login'
  const { browserHistory } = services
  return (
    <Router history={browserHistory}>
      <MetronomeProvider theme={muiBankTheme}>
        <HostServicesContext.Provider value={services}>
          <ErrorBoundary hostServices={services} name={name}>
            <Login />
          </ErrorBoundary>
        </HostServicesContext.Provider>
      </MetronomeProvider>
    </Router>
  )
}

export default App
